import axios from 'axios'
import _ from 'lodash'

import { CODIGO_USUARIO_KEY, RESPONSABILIDADE_UNIDADE_KEY } from '../reducers/filtrosReducer'
import { SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'
import { VISAO_POR_AUDITOR_AGRUPADOR } from '../actions/itensPorVisaoActions'

export const axiosWrapper = axios

export const visoesLabels = {
  [VISAO_POR_AUDITOR_AGRUPADOR]: 'PESSOAL'
}

export const filtrosPorVisao = {
  [VISAO_POR_AUDITOR_AGRUPADOR]: []
}

const GERENCIAL = 'gerencial'
export const PROCESSOS = 'processos'
const PROCESSOS_ADM = 'processos-adm'
export const DOCUMENTOS = 'documentos'
export const COMUNICACOES = 'comunicacoes'
const E_ETCU_LEGADO = 'gestao-processual'
const E_ETCU_GABINETES = 'etcuGabinetes'

export const sistemas = {
  gerencial: { id: GERENCIAL, uri: GERENCIAL },
  processos: { id: PROCESSOS, uri: PROCESSOS },
  processosAdm: { id: PROCESSOS_ADM, uri: PROCESSOS },
  documentos: { id: DOCUMENTOS, uri: DOCUMENTOS },
  comunicacoes: { id: COMUNICACOES, uri: COMUNICACOES },
  comunicacoesAgElaboracao: { id: COMUNICACOES, uri: PROCESSOS },
  etcu: { id: E_ETCU_LEGADO, uri: E_ETCU_LEGADO },
  etcuGabinetes: { id: E_ETCU_GABINETES, uri: E_ETCU_GABINETES }
}

export const destaqueCoparticipantes = {
  identificador: 'contemCoparticipantes',
  descricao: null
}

export const PORTAL_ORIGIN_ACCESS = 'portal'

export const isFiltroSelecionadoMenuFiltros = (filtros, filterKey) => {
  return Boolean(
    filterKey !== RESPONSABILIDADE_UNIDADE_KEY &&
      filterKey !== CODIGO_USUARIO_KEY &&
      _.size(filtros[filterKey])
  )
}

export const isFiltroVisivel = (visao, filterKey) =>
  filtrosPorVisao[visao].indexOf(filterKey) !== -1 || filterKey === RESPONSABILIDADE_UNIDADE_KEY

export const extrairVisaoPorAuditor = (dados) => ({
  visao: {
    total: dados.total,
    processosPorServidor: dados.processosPorServidor,
    processosAdmPorServidor: dados.processosAdmPorServidor,
    processosAdmQueAtueiPorAuditor: dados.processosAdmQueAtueiPorUsuario,
    documentosPorServidor: dados.documentosPorServidor,
    comunicacoesPorServidor: dados.comunicacoesPorServidor,
    processosQueInstruiPorAuditor: dados.processosQueInstruiPorUsuario,
    processosQueAtueiPorAuditor: dados.processosQueAtueiPorUsuario,
    documentosQueAtueiPorAuditor: dados.documentosQueAtueiPorAuditor,
    processosDocumentosPendentesJuntada: dados.processosDocumentosPendentesJuntada,
    historicosItensAcessadosUsuario: dados.historicosItensAcessadosUsuario,
    informacoesAuditor: dados.informacoesAuditor
  }
})

export const getUrlLinksPrincipaisUrl = (idSistema) => `/bff/url-links-principais/${idSistema}`

export const visualizarUrlSistemaLinksPrincipais = (idSistema, callback) => {
  const url = getUrlLinksPrincipaisUrl(idSistema)
  axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const urlSistemaExterno = response.data
      callback(urlSistemaExterno)
    }
  })
}

export const getUrlLinksExternosUrl = (idSistema) => `/bff/url-links-externos/${idSistema}`

export const visualizarUrlSistemaLinksExternos = (idSistema, callback) => {
  const url = getUrlLinksExternosUrl(idSistema)
  axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const urlSistemaExterno = response.data
      callback(urlSistemaExterno)
    }
  })
}

export const getUrlSistemaInstrucaoRepresentacao = () => '/bff/url-instrucao-representacao'

export const viusalizarUrlSistemaInstrucaoRepresentacao = (callback) => {
  axios.get(getUrlSistemaInstrucaoRepresentacao(), SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const urlSistemaInstucao = response.data
      callback(urlSistemaInstucao)
    }
  })
}
export const getUrlSistemaEGestaoUrl = (codigoMenu) => `/bff/url-menu-usuario/${codigoMenu}`

export const visualizarSistemaEGestao = (codigoMenu, callback) => {
  const url = getUrlSistemaEGestaoUrl(codigoMenu)
  axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const urlSistemaExterno = response.data
      callback(urlSistemaExterno)
    }
  })
}

export const VISAO_PROCESSOS = 'visaoProcessos'
export const VISAO_PROCESSOS_POR_FASES_AGRUPADOR = 'visaoPorFasesAgrupador'
export const VISAO_PROCESSOS_POR_RELATOR_AGRUPADOR = 'visaoPorRelatorAgrupador'
export const VISAO_PROCESSOS_POR_UNIDADE_JURISDICIONADA_AGRUPADOR =
  'visaoPorUnidadeJurisdicionadaAgrupador'
export const VISAO_PROCESSOS_POR_TIPO_AGRUPADOR = 'visaoPorTipoAgrupador'
export const VISAO_PROCESSOS_POR_TAG_AGRUPADOR = 'visaoPorTagAgrupador'
export const VISAO_PROCESSOS_POR_ANO_AGRUPADOR = 'visaoPorAnoAgrupador'
export const VISAO_PROCESSOS_POR_UNIDADE_AGRUPADOR = 'visaoPorUnidadeAgrupador'
export const VISAO_PROCESSOS_POR_UF_AGRUPADOR = 'visaoPorUFAgrupador'
export const VISAO_PROCESSOS_POR_FUNCAO_GOVERNO_AGRUPADOR = 'visaoPorFuncaoGovernoAgrupador'
export const VISAO_PROCESSOS_POR_GRUPO_CONECTA_AGRUPADOR = 'visaoPorGrupoConectaAgrupador'
export const VISAO_PROCESSOS_POR_CAUTELAR_AGRUPADOR = 'visaoPorCautelarAgrupador'

export const visoesProcessos = {
  [VISAO_PROCESSOS]: 'PROCESSOS',
  [VISAO_PROCESSOS_POR_UNIDADE_AGRUPADOR]: 'SITUAÇÃO',
  [VISAO_PROCESSOS_POR_TIPO_AGRUPADOR]: 'TIPO',
  [VISAO_PROCESSOS_POR_FASES_AGRUPADOR]: 'FASE',
  [VISAO_PROCESSOS_POR_TAG_AGRUPADOR]: 'TAG',
  [VISAO_PROCESSOS_POR_UNIDADE_JURISDICIONADA_AGRUPADOR]: 'UNIDADE JURISDICIONADA',
  [VISAO_PROCESSOS_POR_GRUPO_CONECTA_AGRUPADOR]: 'GRUPO CONECTA',
  [VISAO_PROCESSOS_POR_CAUTELAR_AGRUPADOR]: 'CAUTELAR',
  [VISAO_PROCESSOS_POR_UF_AGRUPADOR]: 'UNIDADE FEDERATIVA',
  [VISAO_PROCESSOS_POR_FUNCAO_GOVERNO_AGRUPADOR]: 'FUNÇÃO GOVERNO',
  [VISAO_PROCESSOS_POR_RELATOR_AGRUPADOR]: 'RELATOR',
  [VISAO_PROCESSOS_POR_ANO_AGRUPADOR]: 'ANO'
}

export const VISAO_PROCESSOS_ADM = 'visaoProcessos-adm'
export const VISAO_PROCESSOS_ADM_POR_UNIDADE_AGRUPADOR = 'visaoPorUnidadeAgrupador'

export const visoesProcessosAdm = {
  [VISAO_PROCESSOS_ADM]: 'PROCESSOS ADM.',
  [VISAO_PROCESSOS_ADM_POR_UNIDADE_AGRUPADOR]: 'SITUAÇÃO'
}

export const VISAO_COMUNICACOES = 'visaoComunicacoes'
export const VISAO_COMUNICACOES_POR_UNIDADE_AGRUPADOR = 'visaoPorUnidadeAgrupador'

export const visoesComunicacoes = {
  [VISAO_COMUNICACOES]: 'COMUNICAÇÕES',
  [VISAO_COMUNICACOES_POR_UNIDADE_AGRUPADOR]: 'SITUAÇÃO'
}

export const VISAO_DOCUMENTOS = 'visaoDocumentos'
export const VISAO_DOCUMENTOS_POR_UNIDADE_AGRUPADOR = 'visaoPorUnidadeAgrupador'
export const VISAO_DOCUMENTOS_POR_TIPO_AGRUPADOR = 'visaoPorTipoAgrupador'
export const VISAO_POR_UNIDADE_REGISTRO_ENTRADA_AGRUPADOR =
  'visaoPorUnidadeRegistroEntradaAgrupador'

export const visoesDocumentos = {
  [VISAO_DOCUMENTOS]: 'DOCUMENTOS',
  [VISAO_DOCUMENTOS_POR_UNIDADE_AGRUPADOR]: 'SITUAÇÃO',
  [VISAO_DOCUMENTOS_POR_TIPO_AGRUPADOR]: 'TIPO',
  [VISAO_POR_UNIDADE_REGISTRO_ENTRADA_AGRUPADOR]: 'REGISTRO DE ENTRADA'
}

export const getFiltrosObjetosUsuarioURL = (codigoUsuario) => `/bff/filtros/${codigoUsuario}`

export const recuperarFiltrosObjetosUsuario = (codigoUsuario, callback) => {
  axios.get(getFiltrosObjetosUsuarioURL(codigoUsuario), SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const filtrosObjetosUsuario = response.data
      callback(filtrosObjetosUsuario)
    }
  })
}

export const recuperarTipoVinculoUsuarioUnidade = (login, callback) => {
  const url = `/bff/publico/tipo-vinculo-usuario-unidade/${login}`
  axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
    if (callback) {
      const tipoVinculoUsuarioUnidade = response.data
      callback(tipoVinculoUsuarioUnidade)
    }
  })
}
